import { render, staticRenderFns } from "./BusdevFleetPerformance.vue?vue&type=template&id=16ff14af"
import script from "./BusdevFleetPerformance.vue?vue&type=script&lang=js"
export * from "./BusdevFleetPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports